import { Button, Stack } from '@mui/material'
import { AuthFormTitle } from '../AuthFormTitle/AuthFormTitle'
import { RegistrationChoiceOption } from '../RegistrationChoiceOption/RegistrationChoiceOption'

/**
 * Second step of Family registration, mirroring the trainee flow: a partner code and a card
 * purchase are offered as equal options. Titles only, by request from QA (07.10) — the user does
 * not need to know whether their code is funded, the backend decides that on the next step.
 */
export function FamilyRegistrationChoice({
  onUsePartnerCode,
  onPayWithCard,
  onCancel,
}: {
  onUsePartnerCode: () => void
  onPayWithCard: () => void
  onCancel: () => void
}) {
  return (
    <Stack direction="column" spacing={2}>
      <AuthFormTitle textColor="secondary.main" mb={0}>
        How would you like to get access?
      </AuthFormTitle>

      <RegistrationChoiceOption title="Enter Partner Code" onClick={onUsePartnerCode} />

      <RegistrationChoiceOption title="No Code / Pay with Card" onClick={onPayWithCard} />

      <Stack alignItems="center" pt={1}>
        <Button onClick={onCancel} variant="outlined" color="info" sx={{ minWidth: 200 }}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  )
}
